<template>
    <div>
        <treeselect
                valueFormat="object"
                v-model="currentSelected"
                :multiple="true"
                :async="false"
                :options="currentOptions"
                :clear-on-select="true"
                ref="select"

                :placeholder="currentLang.placeholder"
                :retryTitle="currentLang.retryTitle"
                :retryText="currentLang.retryText"
                :noOptionsText="currentLang.noOptionsText"
                :noResultsText="currentLang.noResultsText"
                :noChildrenText="currentLang.noChildrenText"
                :searchPromptText="currentLang.searchPromptText"
                :clearValueText="currentLang.clearValueText"
                :clearAllText="currentLang.clearAllText"
        ></treeselect>

        <input type="hidden" name="tags" v-model="encodedData">
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        components: {
            Treeselect
        },
        props: {
            lang: {
                required:false,
                type: Object
            },
            selected: {
                required: false,
                type: Array
            },
            options: {
                required: true,
                type: Array
            }
        },
        data () {
            return {
                currentLang: {
                    'placeholder': 'Select...',
                    'retryTitle': 'Click to retry',
                    'retryText': 'Retry?',
                    'noOptionsText': 'No options available.',
                    'noResultsText': 'No results found...',
                    'noChildrenText': 'No sub-options.',
                    'searchPromptText': 'Type to search...',
                    'clearValueText': 'Clear value',
                    'clearAllText': 'Clear all'
                },
                currentSelected: null,
                currentOptions: []
            }
        },
        methods: {
            changeLang() {
                _.forEach(this.lang, (value, key) => {
                    this.currentLang[key] = value;
                });
            }
        },
        computed: {
            encodedData() {
                return JSON.stringify(this.currentSelected);
            }
        },
        mounted () {
            this.currentSelected = this.selected.map(i => ({
                id: `${i.id}`,
                label: `${i.name}`
            }));

            this.currentOptions = this.options.map(i => ({
                id: `${i.id}`,
                label: `${i.name}`
            }));

            this.changeLang();
        }
    }
</script>

<style scoped>

</style>
